/* eslint-disable @typescript-eslint/no-unsafe-return */

import {FunctionalComponent, h} from "@stencil/core";
import {CheckboxCell, TableHeader, TableIconHeader, TableSkeleton, TextCell, Topic} from "./notification-settings.sub";
import type {IAsset, IUserSettingsAsset} from "@trumpf/notifies.user-settings-handler";
import {i18nProvider} from "@trumpf/ux.i18n";

//TODO ALL ASSETS : fix icon/tooltip position error
//TODO ALL ASSETS : fix tooltip text: 'toggle all (visible/filtered) assets'
//TODO merge assets & userSettingsAssets in the store, remove artifacts here
//TODO add unconfiguredAssetsTooltip to i18n
//TODO fix ux-input-field clearable, error, onChange

export const AssetsSection: FunctionalComponent<{
	topic: {headlineSlot: string; textSlot: string};
	table: {headerSlot: string};
	isLoading: boolean;

	//! merge both in the store
	assets: IAsset[];
	userSettingsAssets: IUserSettingsAsset[];

	loadMoreAssets: () => void;
	updateAssets: (id: string | string[], enabled: boolean) => void;
	assetsFilter: string;
	updateAssetsFilter: (value: string) => void;
}> = ({topic, table, isLoading, assets, userSettingsAssets, loadMoreAssets, updateAssets, assetsFilter, updateAssetsFilter}) => {
	//! to be removed once assets & userSettingsAssets are merged in the store
	const xAssets =
		assets.length > 0
			? assets.map(({assetName, assetId}) => {
					const userAsset = userSettingsAssets.find((userAsset) => userAsset.id === assetId);

					return {
						...{assetName, assetId},
						enabled: userAsset?.enabled !== undefined ? userAsset.enabled : null,
					};
				})
			: [];

	const filteredAssets = xAssets.filter(
		({assetName, assetId}) => assetName.toLowerCase().includes(assetsFilter.toLowerCase()) || assetId.toLowerCase().includes(assetsFilter.toLowerCase()),
	);

	const hasUnconfiguredAssets = xAssets.some(({enabled}) => enabled === null);

	const {t} = i18nProvider;

	return (
		<section>
			<Topic headlineSlot={topic.headlineSlot} textSlot={topic.textSlot} />
			<ux-input-field
				// clearable={true} //! not working as expected, see onChange
				placeholder={t("user-settings:assetsFilter")}
				value={assetsFilter}
				// error={!isLoading && filteredAssets.length === 0 && assetsFilter !== ""} //! not working as expected, does not show error state when updating the filter
				// onChange={() => updateAssetsFilter("")} //! not working as expected, is called on each rerender
				onInput={(e: Event) => updateAssetsFilter((e.target as HTMLInputElement).value)}
				class="u-marginBottom-25"
			/>
			{/* //! ux-scrollable-container is logging junk to the console, reactivate when fixed by ui lib */}
			{/* <ux-scrollable-container scrollbar-placement="top-bottom" class="u-marginBottom-50 asset-table-container"> */}
			<div class="u-marginBottom-50 asset-table-container">
				<ux-table fullWidth mobileAccordion={false} fixed-col-index="0" max-fixed-col-width="64">
					<table>
						<thead>
							<tr>
								<th>
									<ux-checkbox
										disabled={filteredAssets.length === 0}
										checked={filteredAssets.length > 0 && filteredAssets.every((asset) => asset.enabled)}
										onChange={(e: Event) =>
											updateAssets(
												filteredAssets.map(({assetId}) => assetId),
												(e.target as HTMLInputElement).checked,
											)
										}
									/>
									{/* //! not working as expected, linebreak between checkbox and icon... */}
									{/* <ux-icon name="square-info" weight="bold" />
									<ux-tooltip tooltip-target={"ux-icon[name=square-info]"} align="top">
										{t("user-settings:allAssetsText")}
									</ux-tooltip> */}
								</th>
								{hasUnconfiguredAssets ? (
									<TableIconHeader headerSlot={table.headerSlot} icon="triangle-warning" tooltip={t("user-settings:unconfiguredAssets")} />
								) : (
									<TableHeader headerSlot={table.headerSlot} />
								)}
							</tr>
						</thead>
						<tbody>
							{isLoading ? (
								<TableSkeleton columns={2} rows={2} />
							) : (
								filteredAssets.map(({assetName, assetId, enabled}) => (
									<tr>
										<CheckboxCell
											label={enabled === null ? "*" : ""}
											isChecked={enabled !== null ? enabled : true}
											onChange={(e: Event) => {
												updateAssets(assetId, (e.target as HTMLInputElement).checked);
											}}
										/>
										<TextCell text={`${assetName} (${assetId})`} />
									</tr>
								))
							)}
						</tbody>
					</table>
				</ux-table>
				<ux-infinite-scroll-sensor onUxInfiniteScrollSensorScrolledIntoView={() => loadMoreAssets()} />
				{/* </ux-scrollable-container> */}
			</div>
		</section>
	);
};
